import React from "react";
import { Box, Typography } from "@mui/material";

export function ImagePopover(props: { imageName: string; imageSrc: string | undefined }) {
  if (props.imageSrc === undefined) {
    return <></>;
  }

  return (
    <>
      <Box className="popover-container">
        <Typography variant="h4" color="white">
          {props.imageName}
        </Typography>
        <img className="popover-image" src={props.imageSrc} alt={props.imageName} />
      </Box>
    </>
  );
}
